import { AspPayBillRequest } from 'vopay';
import { useState } from 'react';
import { useApi } from '#shared/providers/Api';

export default function usePayAspBill() {
  const api = useApi();
  const [paying, setPaying] = useState(false);

  async function payAspBill(params: AspPayBillRequest) {
    try {
      setPaying(true);
      const res = await api.payAspBill(params);
      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setPaying(false);
    }
  }

  return { paying, payAspBill };
}
